import React, { createContext, useContext, useState, useCallback } from 'react'
import ShowToast from './showToast'

const ToastContext = createContext()

// simple ID generator
const generateId = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 5)

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const removeToast = useCallback(id => {
    setToasts(prev => prev.filter(toast => toast.id !== id))
  }, [])

  const showToast = useCallback(
    (type, message, duration = 5000) => {
      const id = generateId()
      setToasts(prev => [...prev, { id, type, message, open: true, duration }])

      // auto dismiss
      setTimeout(() => removeToast(id), duration)
    },
    [removeToast]
  )

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toasts.map(({ id, type, message, open, duration }) => (
        <ShowToast
          key={id}
          id={id}
          type={type}
          message={message}
          open={open}
          duration={duration}
          onClose={removeToast}
        />
      ))}
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)
  const showToast = context?.showToast || (() => {})
  return {
    showSuccess: (msg, d) => showToast('success', msg, d),
    showError: (msg, d) => showToast('error', msg, d),
    showWarning: (msg, d) => showToast('warning', msg, d),
    showInfo: (msg, d) => showToast('info', msg, d)
  }
}
